import * as yup from "yup";
import { BRANDING_DISPLAY_NAME_MAX_LENGTH } from "./constants";
// Color configuration is disabled — see BrandingForm.jsx / BrandingProvider.jsx.
// import { AA_MIN, contrastRatio, isHexColor } from "./contrast";

// const HEX_REGEX = /^#[0-9A-Fa-f]{6}$/;

// const requiredHex = yup
//   .string()
//   .trim()
//   .required("This field is required")
//   .matches(HEX_REGEX, "Enter a valid hex color like #0055FF");

// Cross-field WCAG AA check — `pairField` is the sibling color this field
// must contrast against (e.g. primaryColorContrast vs primaryColor). Skips
// silently if either side isn't a valid hex yet — the format test above
// already reports that failure, no need to double up.
// const withContrastCheck = (schema, pairField, label) =>
//   schema.test("wcag-aa-contrast", function (value) {
//     const paired = this.parent?.[pairField];
//     if (!isHexColor(value) || !isHexColor(paired)) return true;
//     const ratio = contrastRatio(value, paired);
//     if (ratio >= AA_MIN) return true;
//     return this.createError({
//       message: `${label}: contrast ratio ${ratio.toFixed(2)}:1 is below the required ${AA_MIN}:1 (WCAG AA).`,
//     });
//   });

const brandingValidationSchema = yup.object({
  displayName: yup
    .string()
    .trim()
    .required("Display name is required")
    .max(BRANDING_DISPLAY_NAME_MAX_LENGTH, `Display name must be ${BRANDING_DISPLAY_NAME_MAX_LENGTH} characters or less`),

  // primaryColor: requiredHex,
  // primaryColorContrast: withContrastCheck(requiredHex, "primaryColor", "Light-mode primary"),
  // primaryColorDark: requiredHex,
  // primaryColorContrastDark: withContrastCheck(requiredHex, "primaryColorDark", "Dark-mode primary"),

  expectedUpdatedAt: yup.mixed().nullable(),
});

export default brandingValidationSchema;
